import Avatar from '@redbubble/design-system/src/Avatar';
import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import { ReactNode } from 'react';
import styles from './Avatar.module.scss';

export interface AvatarStackProps {
  avatar?: String;
  children: ReactNode;
  href?: string | null;
  onClick?: () => void;
}

export const AvatarStack: React.FC<AvatarStackProps> = ({
  avatar,
  children,
  href,
  onClick,
}: AvatarStackProps) => {
  return (
    <Box display="flex" className={styles.avatarContainer}>
      <Avatar
        data-testid="avatar-stack-avatar"
        src={avatar}
        size={constants.MEDIUM}
        loading={!avatar}
        href={href}
        onClick={onClick}
      />
      <Box marginBottom="xs" />
      <Box className={styles.childrenContainer}>{children}</Box>
    </Box>
  );
};
